module.exports = __webpack_public_path__ + "static/electric-bg-big-6988ea9134c9ce1cd9f95bdf9866cb80.png";